import React from "react";
import { Link } from "react-router-dom";
import arrow from "../../assets/logos/lindsay-adams-media-and-design-arrow.svg";
import "./ServiceLink.scss";

export default function ServiceLink({ title, to }) {
    return (
      <Link to={to} className="service-link">
        <img src={arrow} alt="arrow" className="service-link__icon" />
        <div className="service-link__title">{title}</div>
      </Link>
    );
  }